<!--<div class="container " [ngStyle]="{'background-image': getUrl()}">-->
<div class="container container_no_spaces">
  <div class="row justify-content-center text-center">
    <div class="col mb-3">
      <!-- (Espacio reservado para separación) -->
    </div>
  </div>

  <div class="row justify-content-center row-register2">
    <div class="col col-sm-10 col-md-8 col-lg-6 justify-content-center">
      <form
        class="container container_inner"
        [formGroup]="addToClassForm"
        (ngSubmit)="addToClass()"
      >
        <div class="form-group">
          <label for="username">{{ 'ADD_TO_CLASS.EMAIL_LABEL' | translate }}</label>
          <span class="input-group-addon"
            ><i class="glyphicon glyphicon-envelope"></i
          ></span>
          <input
            formControlName="username"
            [ngClass]="{
              'is-invalid':
                addToClassForm.get('username').errors &&
                addToClassForm.get('username').touched
            }"
            type="email"
            class="form-control"
            id="username"
            placeholder="{{ 'ADD_TO_CLASS.EMAIL_PLACEHOLDER' | translate }}"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              addToClassForm.get('username').touched &&
              addToClassForm.get('username').hasError('required')
            "
          >
            {{ 'ADD_TO_CLASS.EMAIL_REQUIRED' | translate }}
          </div>
        </div>
        <div class="form-group">
          <label for="password">{{ 'ADD_TO_CLASS.PASSWORD_LABEL' | translate }}</label>
          <input
            formControlName="password"
            [ngClass]="{
              'is-invalid':
                addToClassForm.get('password').errors &&
                addToClassForm.get('password').touched
            }"
            type="password"
            class="form-control"
            id="password"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              addToClassForm.get('password').hasError('required') &&
              addToClassForm.get('password').touched
            "
          >
            {{ 'ADD_TO_CLASS.PASSWORD_REQUIRED' | translate }}
          </div>
        </div>

        <div class="form-group">
          <label for="listofnames">{{ 'ADD_TO_CLASS.NAMES_LIST_LABEL' | translate }}</label>
          <input
            formControlName="listofnames"
            [ngClass]="{
              'is-invalid':
                addToClassForm.get('listofnames').errors &&
                addToClassForm.get('listofnames').touched
            }"
            type="text"
            class="form-control"
            id="new-password"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              addToClassForm.get('listofnames').hasError('required') &&
              addToClassForm.get('listofnames').touched
            "
          >
            {{ 'ADD_TO_CLASS.NAMES_LIST_REQUIRED' | translate }}
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-outline-primary"
            [disabled]="!addToClassForm.valid"
            type="submit"
          >
            {{ 'ADD_TO_CLASS.ADD_TO_CLASS_BUTTON' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-outline-success ml-3"
            (click)="register()"
          >
            {{ 'ADD_TO_CLASS.REGISTER_BUTTON' | translate }}
          </button>
          <!--button type="submit" class="btn btn-primary">Create Account</button>-->
        </div>
        <br />
        <div class="text-center">
          <a [routerLink]="['/login-help']"
            ><span class="font-weight-bold">{{ 'ADD_TO_CLASS.FORGOT_PASSWORD' | translate }}</span></a
          >
          <span> | </span>
          <a [routerLink]="['/contact-us']"
            ><span class="font-weight-bold text-dark">{{ 'ADD_TO_CLASS.NEED_HELP' | translate }}</span></a
          >
        </div>

        <!--<button class="btn btn-primary" type="button" [disabled]= "this.processing">
            <span *ngIf="this.processing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Processing
          </button>-->
      </form>
    </div>
  </div>
</div>
